import { render } from "./wokerDetail17.vue?vue&type=template&id=6add07f0&scoped=true"
import script from "./wokerDetail17.vue?vue&type=script&lang=js"
export * from "./wokerDetail17.vue?vue&type=script&lang=js"

import "./wokerDetail17.vue?vue&type=style&index=0&id=6add07f0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6add07f0"]])

export default __exports__